module.exports = __webpack_public_path__ + "img/3.1c96e0fc.jpg";